import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, Optional, ViewChild } from '@angular/core';
import { CfgARAccountModel } from '../../../../models/accountsReceivable/cfg-ar-account.model';
import { dataARLedger, enumValidValueItem } from '../../_models/ar.models';
import { DataARPaymentModel } from '../../../../models/accountsReceivable/data-ar-payment.model';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { ARService } from '../../ar.service';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { Globals } from '../../../../globals';
import { DataARLedgerListModel } from '../../models/data-ar-ledger-list.model';
import { TdoTableV2Component } from '../../../../tdo-controls/common/tdo-table-v2/tdo-table-v2.component';
import { TdoTableFooterDataModel } from '../../../../tdo-controls/common/tdo-table-v2/models/tdo-table-footer-data.model';
import { CreatePaymentModel } from '../../models/create-payment.model';
import { InsuranceCompanyListModel } from '../../models/insurance-company-list.model';
import { DataARClaimListModel } from '../../models/data-ar-claim-list';
import { TdoTableSelectionEvent } from '../../../../tdo-controls/common/tdo-table-v2/models/tdo-table-selection.event';
import { UiService } from '../../../../services/ui.service';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { CreateLedgerItemForPaymentModel } from '../../models/create-ledger-item-for-payment.model';
import { PaymentMethodConfigurationService } from '../../../configuration/payment-method-configuration/payment-method-configuration.service';
import { LocalStorageService } from '../../../../services/local-storage.service';
import { CfgARPaymentMethodModel } from '../../../../models/accountsReceivable/cfg-ar-payment-method';
import { CfgARPaymentProcessorModel } from '../../../../models/accountsReceivable/cfg-ar-payment-processor.model';
import { ArInsurancePaymentOverpayConfirmComponent } from '../ar-insurance-payment-overpay-confirm/ar-insurance-payment-overpay-confirm.component';
import { InsurancePaymentOverpayListModel } from '../../models/insurance-payment-overpay-list.model';
import { DataARLedgerModel } from '../../../../models/accountsReceivable/data-ar-ledger.model';
import { Constants } from '../../../../constants';
import {
  PaymentProcessorConfigurationService
} from '../../../configuration/payment-processor-configuration/payment-processor-configuration..service';
import { PaymentAmountForDoctorModel } from '../../models/payment-amount-for-doctor.model';
import { DataDoctorArPaymentProcessorModel } from '../../../../models/accountsReceivable/data-doctor-ar-payment-processor.model';
import {
  ArInsurancePaymentProcessorTotalConfirmComponent
} from '../ar-insurance-payment-processor-total-confirm/ar-insurance-payment-processor-total-confirm.component';
import { DataARClaimItemListModel } from '../../models/data-ar-claim-item-list';
import { DialogService } from '../../../../services/dialog.service';
import { ToastrService } from 'ngx-toastr';
import { PAYMENT_SOURCE } from 'src/app/models/constants/payment-source.model';
import { ConversionUtilities } from 'src/app/utilities/conversion.utilities';
import { TdoSelectDialogComponent } from 'src/app/tdo-controls/common/tdo-select-dialog/tdo-select-dialog/tdo-select-dialog.component';
import { EnumARPaymentType } from 'src/app/models/enum/enum-ar-payment-type';
import { LEDGER_ITEM_TYPE } from 'src/app/models/constants/ledger-item-type.model';
import { TdoOrganizerSlideshowDialogComponent } from 'src/app/main-interface/organizer/dialogs/tdo-organizer-slideshow-dialog/tdo-organizer-slideshow-dialog.component';
import { FileManagerService } from 'src/app/modules/file-manager/file-manager.service';
import { OrganizerOpenInImagingModel } from 'src/app/main-interface/controls/tdo-organizer/models/organizer-open-in-imaging.model';
import { DocumentUploadModel } from 'src/app/models/document/document-upload.model';
import { DocumentClassEnum } from 'src/app/models/enum/document/document-class.enum';
import { DocumentTypeEnum } from 'src/app/models/enum/document/document-type.enum';
import { DocumentGroupCreationModel } from 'src/app/models/document/document-group-creation.model';
import { SignalrService } from 'src/app/services/socket/signalr.service';

@Component({
  selector: 'app-ar-insurance-payment',
  templateUrl: './ar-insurance-payment.component.html',
  styleUrls: ['./ar-insurance-payment.component.css']
})
export class ArInsurancePaymentComponent implements OnInit, OnDestroy {

  @ViewChild(TdoTableV2Component) tdoTable: TdoTableV2Component;
  searchPredicate: (data: any, filter: string) => boolean;
  footerData: TdoTableFooterDataModel[] = [];

  arAccounts: CfgARAccountModel[] = [];
  paymentMethods: CfgARPaymentMethodModel[] = [];
  insuranceCompanyList: InsuranceCompanyListModel[] = [];
  insuranceName: string;
  paymentActions: any[] = [];
  paymentCCSources: any[] = [];
  paymentESources: any[] = [];
  ledgerItems: dataARLedger[] = [];
  claims: DataARClaimListModel[] = [];
  claimsRows: DataARClaimListModel[] = [];
  selectedPaymentMethod: CfgARPaymentMethodModel;
  selectedEPaymentType: enumValidValueItem;
  selectedCCPaymentType: enumValidValueItem;
  selectedARAccount: CfgARAccountModel;
  selectedInsuranceCompany: InsuranceCompanyListModel;
  currentARPayment: DataARPaymentModel;
  currentTransactionSetupID: string;
  showOnlyCurrentPatient: boolean = false;
  currentPatientID: string;
  currentPatientName: string;
  currentWorkStationID: string;
  paymentProcessors: CfgARPaymentProcessorModel[] = [];
  insuranceOverPayDistributionList: InsurancePaymentOverpayListModel[] = [];
  insuranceClaimItemOverPayDistributionList: InsurancePaymentOverpayListModel[] = [];

  dataDoctorARPaymentProcessorsAll: DataDoctorArPaymentProcessorModel[] = [];
  dataDoctorARPaymentProcessors: DataDoctorArPaymentProcessorModel[] = [];
  currentDataDoctorARPaymentProcessor: DataDoctorArPaymentProcessorModel;
  currentDataDoctorARPaymentProcessorId: string;

  DocPaymentProcessors: CfgARPaymentProcessorModel[] = [];
  currentPaymentProcessorId: string;
  PaymentAmountForDoctors: PaymentAmountForDoctorModel[];

  claimExpanded: string;

  messagingSubscription: any;
  chargePaymentAmount: boolean = false;
  isLoading: boolean = false;
  isClaimsLoading: boolean = false;
  searchWasEmpty = null;
  paymentAmount: number = 0;
  paymentAmountNotDistributed: number = 0;
  paymentDescription: string;
  datePostPayment: Date;
  dateReceivedPayment: Date;
  datePostPaymentMin: Date;
  showSaveButton: boolean = false;

  enumPaymentTypeE: string = '00000080-1000-0000-0000-000000000003';
  enumCurrencyUSD: string = '00000192-1000-0000-0000-000000000001';
  enumPaymentTransactionTypeIDPurchase: string = '00000277-1000-0000-0000-000000000001';
  enumLedgerItemOriginTypeInsurance: string = '00000207-1000-0000-0000-000000000001';
  enumLedgerItemStatusOutstanding: string = '00000083-1000-0000-0000-000000000001';

  enumARInsurancePaymentActionWriteOff: string = '00000A82-1000-0000-0000-000000000003';
  enumARInsurancePaymentActionPatientPay: string = '00000A82-1000-0000-0000-000000000002';

  searchInput: string = '';
  searchTimer: any;
  searchTerm: string = 'nosearch';
  searchTermValPay: string = '';
  delaySearch: boolean = true;
  includeClosed: boolean = false;
  pageModeType: string = '';
  isClaimRefusal: boolean = false;
  claimTotalNumber: number = 0;
  changesMade: boolean;
  showClosedClaims: boolean = false;
  isPaymentProcessing: boolean = false;
  isSelectingInsurace: boolean = false;
  insuranceDocuments: any[] = [];
  insuranceDocumentTags: any[] = [];
  selectedDocumentTag: string = '';
  selectedDocumentDescription: string;
  isDisabledReceivedDate: boolean;

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ArInsurancePaymentComponent>,
    private readonly uiService: UiService,
    private readonly arService: ARService,
    private readonly ppService: PaymentProcessorConfigurationService,
    private readonly currencyPipe: CurrencyPipe,
    private readonly dialog: MatDialog,
    private readonly globals: Globals,
    private readonly changeDet: ChangeDetectorRef,
    private readonly paymentMethodConfigService: PaymentMethodConfigurationService,
    private readonly localStorageService: LocalStorageService,
    private readonly dialogService: DialogService,
    public datePipe: DatePipe,
    private readonly toastr: ToastrService,
    private readonly signalrService: SignalrService,
    private readonly fileService: FileManagerService
  ) {
    this.searchPredicate = (ledgerData: DataARLedgerListModel, filter: string) => {
      if (ledgerData.dataARTransactionItem) {
        return ledgerData.dataARTransactionItem.Code.toLowerCase().includes(filter)
          || ledgerData.Description.toLowerCase().includes(filter);
      }
      return ledgerData.Description.toLowerCase().includes(filter);
    };
  }

  ngOnDestroy(): void {
    if (this.messagingSubscription) {
      this.messagingSubscription.unsubscribe();
      this.messagingSubscription = null;
    }
  }

  ngOnInit() {
    this.isLoading = true;
    this.dialogRef.keydownEvents().subscribe(event => {
      if (event.key === "Escape") {
        this.cancelClicked();
      }
    });
    this.datePostPayment = new Date();
    this.dateReceivedPayment = new Date();
    this.showOnlyCurrentPatient = true;

    // current patient
    if (this.globals.currentPatientId) {
      this.currentPatientID = this.globals.currentPatientId;
      if (this.globals.ThePatient?.dataContact) {
        this.currentPatientName = this.globals.ThePatient.dataContact.FirstName + ' ' + this.globals.ThePatient.dataContact.LastName;
      }
    }
    this.init();
    if (this.messagingSubscription == null) {
      this.messagingSubscription = this.signalrService.messageUser.subscribe((res) => {
        if (res.messageType == SignalrService.UPDATE_INSURANCE_DOCUMENTS && res.message && res.message['patientId'] === this.currentPatientID) {
          if (res.message['uploadedDocumentId']) {
            this.createInsuranceDocumentGroup(res.message['uploadedDocumentId'], this.globals.currentPatientId).then((result: any) => {
              this.reloadDocuments();
            });
          }
          else
            this.reloadDocuments();
        }
      });
    }
  }

  reloadDocuments() {
    this.getInsuranceDocuments().then((result: any) => {
      this.insuranceDocuments = result.documents;
      this.insuranceDocumentTags = result.tags;
    });
  }

  init() {
    this.currentWorkStationID = this.localStorageService.currentUserData.authdata.WorkStationID;
    const locid = localStorage.getItem('LOCID');

    const promises = [
      this.paymentMethodConfigService.getPaymentMethodList(locid).toPromise(),
      this.getAllInsuranceOrganizationsForCurrentPatient(),
      this.getAllDoctorARLocations(),
      this.getEnumValidValueItemsByValidValueName('enumARInsurancePaymentAction'),
      this.ppService.getValPayPaymentProcessorARLocList().toPromise(),
      this.getInsuranceDocuments()
      // claims
    ];

    this.isLoading = true;
    Promise.all(promises).then((results: any[]) => {
      this.paymentMethods = results[0];
      this.insuranceCompanyList = results[1];
      this.arAccounts = results[2];
      this.paymentActions = results[3];
      this.dataDoctorARPaymentProcessorsAll = results[4];
      console.log('init this.getInsuranceDocuments:', results[5]);
      this.insuranceDocuments = results[5].documents;
      this.insuranceDocumentTags = results[5].tags;

      // load default insurance claims
      console.log('init showOnlyCurrentPatient', this.showOnlyCurrentPatient);
      console.log('init data', this.data);
      console.log('init this.data?.type?.length', this.data?.type?.length);
      if (this.showOnlyCurrentPatient && !this.data?.type) {
        console.log('showOnlyCurrentPatient, load claims');
        this.setAndLoadClaimsForDefaultPatientInsurance();
      }

      // insurance claim refusal
      if (this.data?.type) {
        this.pageModeType = this.data.type;
        if (this.pageModeType === 'insurance-claim-refusal') {
          this.loadClaimRefusal();
        }
      }

      this.isLoading = false;
    }, err => {
      this.createMessage('Something went wrong', 'Error');
      this.isLoading = false;
    });
  }

  searchChanged(change: any) {
    let passedValue: string = '';

    // if there is already a timer running, then stop
    if (this.searchTimer) {
      clearTimeout(this.searchTimer);
    }

    if (change.target.value) {
      passedValue = change.target.value;
    }

    // trigger the search action after 800 mls
    this.searchTimer = setTimeout(() => this.searchClaims(passedValue), 1000);
  }

  searchClaims(searchTerm: string) {
    // holder for search results
    let searchResults: DataARClaimListModel[] = [];
    const searchResultsLocal: DataARClaimListModel[] = [];
    this.claimsRows = [];
    this.isClaimsLoading = true;

    // if we have a search string
    if (searchTerm.length) {

      this.claims.forEach(a => {
        if (a.PatientFirstName?.toUpperCase().includes(searchTerm.toUpperCase())
          || a.PatientLastName?.toUpperCase().includes(searchTerm.toUpperCase())
          || (a.PatientFirstName + ' ' + a.PatientLastName).toUpperCase().includes(searchTerm.toUpperCase())
          || a.TDOClaimNumber && a.TDOClaimNumber.toString() === searchTerm) {
          searchResultsLocal.push(a);
        }
      });

      this.claimsRows = [].concat(searchResultsLocal);
      this.changeDet.detectChanges();

      // if looking for closed claims
      if (this.includeClosed) {
        // go to server for closed matches
        this.searchTerm = searchTerm;
        if (searchTerm.trim() === '') {
          this.searchTerm = 'nosearch';
        }

        let InsuranceID = Constants.emptyGuid;
        let OrganizationID = Constants.emptyGuid;

        if (this.selectedInsuranceCompany?.InsuranceID) { InsuranceID = this.selectedInsuranceCompany.InsuranceID; }
        else if (this.selectedInsuranceCompany?.OrganizationID) { OrganizationID = this.selectedInsuranceCompany.OrganizationID; }

        const promises = [
          this.getAllClaimsWithItems(InsuranceID, OrganizationID)
        ];

        Promise.all(promises).then((results: any[]) => {
          searchResults = results[0];
          if (!this.includeClosed) {
            // filter out zero balance claims
            // this.claimsRows = this.claimsRows.filter(a => a.ClaimAmountOutstanding > 0);
          }
          this.claimsRows = [].concat(searchResults).concat(this.claimsRows);
          this.changeDet.detectChanges();
          this.isClaimsLoading = false;
        }, err => {
          this.createMessage('Something went wrong', 'Error');
          this.isClaimsLoading = false;
        });
      }
      else {
        this.isClaimsLoading = false;
      }
    }
    else {
      // search term is blank
      this.claimsRows = [].concat(this.claims);
      this.isClaimsLoading = false;
    }
  }

  createDataARPaymentRecord() {
    const promise = new Promise((resolve, reject) => {

      const createPayment = new CreatePaymentModel();
      if (this.datePostPayment.getDate() !== new Date().getDate())
        this.datePostPayment.setUTCHours(12, 0, 0, 0);
      createPayment.datePostPayment = this.datePostPayment;
      if (this.dateReceivedPayment.getDate() !== new Date().getDate())
        this.dateReceivedPayment.setUTCHours(12, 0, 0, 0);
      createPayment.dateReceivedPayment = this.dateReceivedPayment;
      createPayment.Description = this.paymentDescription;
      createPayment.enumPaymentSourceID = PAYMENT_SOURCE.Insurance;
      createPayment.DepositARAccountID = this.selectedARAccount.ARAccountID;

      if (this.selectedInsuranceCompany.InsuranceID === Constants.emptyGuid) {
        createPayment.PaymentSourceObjectID = this.selectedInsuranceCompany.OrganizationID;
        createPayment.PatientID = null;
      }
      else {
        createPayment.PaymentSourceObjectID = this.selectedInsuranceCompany.InsuranceID;
        createPayment.PatientID = this.globals.currentPatientId;
      }
      createPayment.paymentAmount = this.paymentAmount;
      createPayment.enumCurrencyID = this.enumCurrencyUSD;
      // createPayment.PatientID = this.globals.currentPatientId; // may need to set this to null for a bulk insurance payment
      createPayment.LOCID = this.globals.LOCID;
      createPayment.enumPaymentTransactionTypeID = this.enumPaymentTransactionTypeIDPurchase;
      if (this.selectedPaymentMethod) {
        createPayment.enumARPayementCCTypeID = this.selectedPaymentMethod.enumARPayementCCTypeID ? this.selectedPaymentMethod.enumARPayementCCTypeID : null;
        createPayment.enumARPayementETypeID = this.selectedPaymentMethod.enumARPayementETypeID ? this.selectedPaymentMethod.enumARPayementETypeID : null;
        createPayment.enumARPayementTypeID = this.selectedPaymentMethod.enumARPayementTypeID ? this.selectedPaymentMethod.enumARPayementTypeID : null;
      }

      this.arService.createDataARPaymentRecord(createPayment)
        .subscribe(resolve, reject);
    });
    return promise;
  }

  setPaymentAmountDistributionRemaining() {
    let paymentsDistributed = 0;
    this.claims.forEach(claim => {
      paymentsDistributed += claim.ApplyPayment;
    });

    // console.log('setPaymentAmountDistributionRemaining paymentsDistributed:', paymentsDistributed);
    this.paymentAmountNotDistributed = ConversionUtilities.roundDecimal(this.paymentAmount - paymentsDistributed);
    // console.log('setPaymentAmountDistributionRemaining paymentAmountNotDistributed:', this.paymentAmountNotDistributed);
    if (this.paymentAmountNotDistributed < 0)
      this.createMessage('Amount distributed is more than the total payment amount.', 'Error');
  }

  createMessage(message, type) {
    if (type.toLowerCase() === "error")
      this.toastr.error(message, null, { timeOut: 7000 });
    else if (type.toLowerCase() === "warning")
      this.toastr.warning(message, null, { timeOut: 5000 });
    else
      this.toastr.success(message, null, { timeOut: 5000 });
  }

  getEnumValidValueItemsByValidValueName(ValidValueName: string) {
    const promise = new Promise((resolve, reject) => {
      this.arService.getEnumValidValueItemsByValidValueName(ValidValueName)
        .subscribe(resolve, reject);
    });
    return promise;
  }

  getAllClaimsWithItems(InsuranceID: string, OrganizationID: string) {
    const promise = new Promise((resolve, reject) => {
      this.arService.getAllClaimsWithItems(InsuranceID, OrganizationID, this.includeClosed, this.searchTerm, this.showOnlyCurrentPatient ? this.currentPatientID : null)
        .subscribe(resolve, reject);
    });
    return promise;
  }

  getInsuranceClaimForLedgerID(LedgerID: string) {
    // console.log('getInsuranceClaimForLedgerID', LedgerID);
    const promise = new Promise((resolve, reject) => {
      this.arService.getInsuranceClaimForLedgerID(LedgerID)
        .subscribe(resolve, reject);
    });
    return promise;
  }

  getAllInsuranceOrganizations() {
    const promise = new Promise((resolve, reject) => {
      this.arService.getAllInsuranceOrganizations()
        .subscribe(resolve, reject);
    });
    return promise;
  }

  getAllInsuranceOrganizationsForCurrentPatient() {
    const promise = new Promise((resolve, reject) => {
      this.arService.getInsuranceOrganizationsForPatientInsurancePayment(this.currentPatientID)
        .subscribe(resolve, reject);
    });
    return promise;
  }

  getAllARAccounts() {
    const promise = new Promise((resolve, reject) => {
      this.arService.getAllARAccounts()
        .subscribe(resolve, reject);
    });
    return promise;
  }

  getAllDoctorARLocations() {
    const promise = new Promise((resolve, reject) => {
      this.arService.getAllDoctorARLocations()
        .subscribe(resolve, reject);
    });
    return promise;
  }

  showSaveButtonCheck() {
    console.log('showSaveButtonCheck');
    //Is payment type selected?
    // console.log('showSaveButtonCheck selectedPaymentMethod:', this.selectedPaymentMethod);
    if (!this.selectedPaymentMethod) {
      console.log('showSaveButtonCheck no payment method selected');
      this.showSaveButton = false;
      return;
    }
    // console.log('showSaveButtonCheck selectedARAccount:', this.selectedARAccount);
    if (!this.selectedARAccount) {
      console.log('showSaveButtonCheck no AR Account selected');
      this.showSaveButton = false;
      return;
    }
    // console.log('showSaveButtonCheck paymentAmountNotDistributed:', this.paymentAmountNotDistributed);
    if (this.paymentAmountNotDistributed < 0) {
      console.log('showSaveButtonCheck paymentAmountNotDistributed < 0');
      this.showSaveButton = false;
      return;
    }
    // console.log('showSaveButtonCheck paymentAmount:', this.paymentAmount);
    if (!this.paymentAmount || this.paymentAmount <= 0) {
      console.log('showSaveButtonCheck paymentAmount < 0');
      this.showSaveButton = false;
      return;
    }
    // check to see if at least one claim distribution can be saved
    let showSave = false;
    const claimsApplied = this.claims.filter(a => a.ApplyPayment > 0);
    if (claimsApplied.length > 0) {
      showSave = claimsApplied.every(claim => {
        let itemsApplyPaymentTotal = 0;
        claim.dataARClaimListItems.forEach(a => {
          itemsApplyPaymentTotal += a.ApplyPayment;
        });
        

        console.log(`showSaveButtonCheck claimsApplied compare amounts:${claim.ApplyPayment }, itemsApplyPaymentTotal: ${itemsApplyPaymentTotal}`);
        // if claim apply amount = sum of amounts applied to claim items
        // console.log('showSaveButtonCheck claim.ApplyPayment:', claim.ApplyPayment);
        // console.log('showSaveButtonCheck itemsApplyPaymentTotal:', itemsApplyPaymentTotal);
        if (ConversionUtilities.roundDecimal(claim.ApplyPayment) === ConversionUtilities.roundDecimal(itemsApplyPaymentTotal)) {
          return true;
        }
        else{
          console.log('showSaveButtonCheck claimsApplied ApplyPayment !=  itemsApplyPaymentTotal');
          return false;
        }
      });
    }
    else if (this.paymentAmount === this.paymentAmountNotDistributed){
      console.log(`showSaveButtonCheck paymentAmount === paymentAmountNotDistributed :${this.paymentAmount } === ${this.paymentAmountNotDistributed}`);

      // no claims applied, all will be created as credit
      showSave = true;
    }

    // console.log('showSaveButtonCheck showSave:', showSave);
    // if no claims can be saved, disable button
    this.showSaveButton = showSave;
    // force change detection
    this.changeDet.detectChanges();
    this.changeDet.markForCheck();
  }

  saveTotalAmount(event) {
    const inputValue = event.target.value;

    this.paymentAmount = ConversionUtilities.roundDecimal(Number(inputValue.replace(/[^0-9.-]+/g, '')));
    this.paymentAmountNotDistributed = this.paymentAmount;
    this.resetApplyPaymentAmounts();
    this.autoApplyRemainingAmount();

    this.showSaveButtonCheck();
  }


  saveCurrencyField(event, fieldName, ClaimID, ClaimItemID) {
    const inputValue = event.target.value;

    switch (fieldName) {
      case 'paymentAmount': {
        this.paymentAmount = ConversionUtilities.roundDecimal(Number(inputValue.replace(/[^0-9.-]+/g, '')));
        this.paymentAmountNotDistributed = this.paymentAmount;
        this.resetApplyPaymentAmounts();
        this.autoApplyRemainingAmount();
        break;
      }
      case 'ApplyPayment': {
        const num = Number(inputValue.replace(/[^0-9.-]+/g, ''));
        const claimModified = this.claims.find(a => a.ARClaimID === ClaimID);

        if (claimModified) {
          // temporarily restore previous payment amount to this.paymentAmountNotDistributed
          this.paymentAmountNotDistributed = ConversionUtilities.roundDecimal(this.paymentAmountNotDistributed) + ConversionUtilities.roundDecimal(claimModified.ApplyPayment);
          // set raw value
          claimModified.ApplyPayment = num;
          claimModified.claimExpanded = true;
          this.claimExpanded = claimModified.ARClaimID;

          // finally, if main apply amount is now less than sum of claim item amounts, clear claim item amounts
          let claimItemsApplyTotal: number = 0;
          claimModified.dataARClaimListItems.forEach(a => {
            if (a.ApplyPayment) {
              claimItemsApplyTotal += a.ApplyPayment;
            }
          });
          if (claimModified.ApplyPayment < ConversionUtilities.roundDecimal(claimItemsApplyTotal) || claimModified.ApplyPayment == 0) {
            claimModified.dataARClaimListItems.forEach(a => {
              if (a.ApplyPayment) {
                a.ApplyPayment = 0;
              }
            });
          }
        }

        // after update above, set available distribution amount
        this.setPaymentAmountDistributionRemaining();
        this.showSaveButtonCheck();
        break;
      }
      case 'ApplyPaymentClaimItem': {
        const num = Number(inputValue.replace(/[^0-9.-]+/g, ''));
        this.claims.forEach(claim => {
          if (claim.ARClaimID.toUpperCase() === ClaimID.toUpperCase()) {

            // get total of applied amounts of other claim items for claim
            let claimItemsApplyTotal = 0;
            claim.dataARClaimListItems.forEach(claimitemSum => {
              if (claimitemSum.ARClaimItemID !== ClaimItemID) {
                claimItemsApplyTotal += claimitemSum.ApplyPayment;
              }
            });

            claim.dataARClaimListItems.forEach(claimitem => {
              if (claimitem.ARClaimItemID.toUpperCase() === ClaimItemID.toUpperCase()) {
                // set raw value
                claimitem.ApplyPayment = num;
                // force change detection
                this.changeDet.detectChanges();

                if (num > claim.ApplyPayment) {
                  claimitem.ApplyPayment = 0;
                  this.createMessage('Amount entered is more than applied to claim', 'Error');
                }
                else if (ConversionUtilities.roundDecimal(num + claimItemsApplyTotal) > claim.ApplyPayment) {
                  claimitem.ApplyPayment = 0;
                  this.createMessage('Amount entered makes the sum of the applied payments to claim items exceed that of the claim', 'Error');
                }
                // update button visibility
              }
            });
          }
        });
        break;
      }
    }
    this.showSaveButtonCheck();
  }

  setMinReceivedDate() {
    if (this.selectedPaymentMethod && this.selectedPaymentMethod.enumARPayementTypeID === this.enumPaymentTypeE) {
      this.datePostPaymentMin = new Date();
      if (this.datePostPayment < this.datePostPaymentMin) {
        this.datePostPayment = this.datePostPaymentMin;
      }
    }
    else {
      this.datePostPaymentMin = null;
    }
  }


  checkIfTotalIsValid() {
    if (this.paymentAmount) {
      if (this.paymentAmount > 0 && this.selectedInsuranceCompany && this.selectedARAccount) {
        return true;
      }
      else {
        return false;
      }
    }
    else {
      return false;
    }
  }

  async submitPayment() {
    this.isPaymentProcessing = true;
    console.log('submitPayment');
    this.createDataARPaymentRecord().then((newPayment: DataARPaymentModel) => {
      this.updateInsuranceDocumentGroup(this.insuranceDocuments.map(d => d.DocumentID), newPayment.PaymetnID).then((result: any) => {
        console.log('createInsuranceDocumentGroup result:', result);
      });
      if (newPayment) {
        this.changesMade = true;
        // expand claim rows if individual selected
        if (this.showOnlyCurrentPatient) {
          this.expandAllClaimsRows();
        }
        // dataARPayments record created
        // record new payment
        this.currentARPayment = newPayment;

        if (this.isClaimRefusal) {
          // setup distributions and save
          // create payment ledger item
          this.createLedgerItemForPayment(newPayment).then((success: number) => {
            if (success) {
              // distributions logic
              this.savePaymentDistributionClickedClaimRefusal();
            }
          });
          this.paymentAmountNotDistributed = 0;
        }
        else {
          // create payment ledger item
          this.createLedgerItemForPayment(newPayment).then((success: number) => {
            if (success) {
              // distributions logic
              //this.savePaymentDistributionBalanceCheck();
              this.savePaymentDistributionClicked();
              if (this.insuranceOverPayDistributionList.length > 0)
                this.createCreditForUndistributedPayment();
              this.paymentAmountNotDistributed = 0;
              this.paymentAmount = 0;
              this.paymentDescription = '';
              this.selectedPaymentMethod = null;
              this.selectedARAccount = null;
              this.LoadClaimsForInsurance();
              this.resetApplyPaymentAmounts();
            }
          });
        }
      }
    }, err => {
      this.isPaymentProcessing = false;
      console.log('Create Ledger Item err:', err);
      this.createMessage('Problem creating payment record', 'Error');
    });
  }

  close(payload) {
    this.dialogRef.close(payload);
  }

  LoadClaimsForInsurance() {
    // console.log('LoadClaimsForInsurance');
    this.isPaymentProcessing = false;
    this.paymentAmount = 0;
    this.showSaveButtonCheck();
    this.isClaimsLoading = true;

    let InsuranceID = Constants.emptyGuid;
    let OrganizationID = Constants.emptyGuid;

    if (this.selectedInsuranceCompany?.InsuranceID && this.selectedInsuranceCompany?.InsuranceID !== Constants.emptyGuid)
      InsuranceID = this.selectedInsuranceCompany.InsuranceID;
    else if (this.selectedInsuranceCompany?.OrganizationID && this.selectedInsuranceCompany?.OrganizationID !== Constants.emptyGuid)
      OrganizationID = this.selectedInsuranceCompany.OrganizationID;

    const promises = [
      this.getAllClaimsWithItems(InsuranceID, OrganizationID)
    ];

    Promise.all(promises).then((results: any[]) => {
      // console.log('getAllClaimsWithItems results', results);
      this.claims = results[0];
      this.claimsRows = this.claims;
      // dont show claims with 0 balance
      // this.claimsRows = this.claimsRows.filter(a => a.ClaimAmountOutstanding > 0);
      if (this.claimsRows.length === 0) {
        this.searchWasEmpty = true;
      }
      else {
        this.searchWasEmpty = false;
      }
      this.claimTotalNumber = this.claimsRows.length;
      this.isClaimsLoading = false;
      this.isLoading = false;
    }, err => {
      this.createMessage('Something went wrong', 'Error');
      this.isClaimsLoading = false;
      this.isLoading = false;
    });
  }

  // Handle selection and deselection of rows model data
  onRowSelected(event: TdoTableSelectionEvent) {
    const claimsModel = this.claims.find(p => p === event.model);
    if (claimsModel) {
      claimsModel.DATA_SELECTED = event.isSelected;
    }
  }

  convertUTCDateToLocalDateFromString(dateString) {
    if (!dateString) {
      return null;
    }
    const date = new Date(dateString);
    return this.convertUTCDateToLocalDate(date);
  }

  convertUTCDateToLocalDate(date) {
    return new Date(
      Date.UTC(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds()
      )
    );
  }

  async savePaymentDistributionBalanceCheck() {
    // if there is any amount undistributed, show dialog asking if user wants to credit that amount, or continue distributing
    this.insuranceOverPayDistributionList = [];
    this.insuranceClaimItemOverPayDistributionList = [];

    // check for over-distributed claim items
    this.claimsRows.forEach(claim => {
      claim.dataARClaimListItems.forEach(claimItem => {
        if (claimItem.ApplyPayment > 0 && claimItem.ApplyPayment > claimItem.AmountOutstanding) {
          // add to list of over-payments to credit
          const itemOverpay = new InsurancePaymentOverpayListModel();
          itemOverpay.PatientID = claim.PatientID;
          //itemOverpay.PaymentID = this.currentARPayment.PaymetnID;
          itemOverpay.ClaimItemID = claimItem.ARClaimItemID;
          itemOverpay.ClaimNumber = claim.TDOClaimNumber;
          itemOverpay.Amount = claimItem.ApplyPayment - claimItem.AmountOutstanding;
          itemOverpay.LOCID = claim.LOCID;
          this.insuranceClaimItemOverPayDistributionList.push(itemOverpay);
        }
      });
    });

    if (this.paymentAmountNotDistributed > 0) {

      // handle overpay distribution list
      let patientClaims: DataARClaimListModel[] = this.claimsRows;
      if (this.showOnlyCurrentPatient) { patientClaims = patientClaims.filter(a => a.PatientID === this.currentPatientID); }
      patientClaims.forEach(c => {
        const dist = new InsurancePaymentOverpayListModel();
        dist.PatientID = c.PatientID;
        dist.PatientName = c.PatientFirstName + ' ' + c.PatientLastName;
        dist.Amount = 0;
        dist.ClaimNumber = c.TDOClaimNumber;
        this.insuranceOverPayDistributionList.push(dist);
      });

      // setup dialog
      const config = new MatDialogConfig();
      config.width = '450px';
      config.height = '500px';
      if (!this.showOnlyCurrentPatient) {
        config.height = '400px';
      }
      config.data = {
        overPayAmount: this.paymentAmountNotDistributed,
        overPayAmountList: this.insuranceOverPayDistributionList
      };
      config.panelClass = 'dialog';

      // open dialog
      const popup = this.dialog.open(ArInsurancePaymentOverpayConfirmComponent, config);
      popup.afterClosed().subscribe(result => {
        // return result
        if (result.length > 0) {
          // move ahead with credit
          console.log('overpaymentconfirm');
          this.isPaymentProcessing = true;
          this.insuranceOverPayDistributionList = result;
          this.submitPayment();
        }
      });
    }
    else {
      this.submitPayment();
    }
  }

  async createCreditForUndistributedPayment() {
    try {

      // credit ledger item
      const ledgerItemCredit = new DataARLedgerModel();
      ledgerItemCredit.LOCID = parseInt(localStorage.getItem('LOCID'));
      ledgerItemCredit.PatientId = this.globals.currentPatientId;
      ledgerItemCredit.PostDate = new Date();
      ledgerItemCredit.Amount = this.paymentAmountNotDistributed;
      ledgerItemCredit.Description = 'Undistributed insurance payment credit - Administrative';
      ledgerItemCredit.Reference = 'Overpay Conversion';
      ledgerItemCredit.enumARLedgerItemTypeID = LEDGER_ITEM_TYPE.CreditAdjustmentInsurance;
      ledgerItemCredit.enumARLedgerItemOriginTypeID = this.enumLedgerItemOriginTypeInsurance;
      ledgerItemCredit.enumLedgerItemStatusID = this.enumLedgerItemStatusOutstanding;
      ledgerItemCredit.PaymetnID = this.currentARPayment.PaymetnID;

      await this.arService.saveLedgerItem(ledgerItemCredit).toPromise();
      this.createMessage('Credit created for undistributed payment amount', 'Success');
      this.isLoading = false;
    } catch (err) {
      console.log('err', err);
      this.createMessage('Credit not created', 'Error');
      this.isLoading = false;
    }
  }

  savePaymentDistributionClickedClaimRefusal() {
    this.isLoading = true;

    // get claims to save
    const claimsToSave: DataARClaimListModel[] = [];
    this.claims.forEach(claim => {
      claimsToSave.push(claim);
    });

    if (claimsToSave.length) {
      this.savePaymentDistribution(claimsToSave, this.insuranceOverPayDistributionList, this.insuranceClaimItemOverPayDistributionList).then((result: number) => {
        if (result) {
          if (result === 1) {
            this.createMessage('Claim refusal succeeded', 'Success!');
            this.dialogRef.close(true);
          }
        }
      }, err => {
        this.createMessage('Problem refusing claim', 'Error');
        this.isLoading = false;
        this.isPaymentProcessing = false;
      });
    }
    else {
      this.createMessage('Problem refusing claim - no claims to refuse', 'Error');
      this.isLoading = false;
      this.isPaymentProcessing = false;
    }
  }

  savePaymentDistributionClicked() {
    this.isLoading = true;
    this.isPaymentProcessing = true;

    // get claims to save
    const claimsToSave: DataARClaimListModel[] = [];
    this.claims.forEach(claim => {

      // only look at claims with an amount applied
      if (claim.ApplyPayment > 0) {

        // get total of applied amounts of other claim items for claim
        let claimItemsApplyTotal = 0;
        claim.dataARClaimListItems.forEach(claimitemSum => {
          claimItemsApplyTotal += claimitemSum.ApplyPayment;
        });

        // if total claim item apply amounts = total claim apply amount, then we can save the claim
        if (ConversionUtilities.roundDecimal(claimItemsApplyTotal) === claim.ApplyPayment) {
          claimsToSave.push(claim);
        }
      }
    });

    if (claimsToSave.length) {

      // prevent apply amounts from exceeding amount owed/outstanding
      // any overpayments will be handled on the server in the call below
      claimsToSave.forEach(a => {
        a.dataARClaimListItems.forEach(b => {
          if (b.ApplyPayment > b.AmountOutstanding) {
            b.ApplyPayment = b.AmountOutstanding;
          }
        });
      });

      this.insuranceClaimItemOverPayDistributionList.forEach(a => {
        a.PaymentID = this.currentARPayment.PaymetnID;
      });

      this.savePaymentDistribution(claimsToSave, this.insuranceOverPayDistributionList, this.insuranceClaimItemOverPayDistributionList).then((result: number) => {
        if (result) {
          if (result === 1) {
            this.createMessage('Insurance payment distribution succeeded', 'Success!');
            this.changesMade = true;
            // reset expansion status
            this.claimExpanded = '';

            // if all distributed...
            if (this.paymentAmountNotDistributed <= 0) {
              // reset payment screen
              this.currentARPayment = null;
              this.paymentAmountNotDistributed = 0;
              this.paymentAmount = 0;
            }
          }
          this.isLoading = false;
          //this.isPaymentProcessing = false;
        }
      }, err => {
        this.createMessage('Problem distributing insurance payment', 'Error');
        this.isLoading = false;
        this.isPaymentProcessing = false;
      });
    }
    else {
      this.isLoading = false;
      this.isPaymentProcessing = false;
    }
    // console.log('savePaymentDistributionClicked ended.');
    // retest button visibility
    this.showSaveButtonCheck();
  }

  savePaymentDistribution(claims: DataARClaimListModel[], insuranceOverPayList: InsurancePaymentOverpayListModel[], insuranceClaimItemOverPayList: InsurancePaymentOverpayListModel[]) {
    // console.log('savePaymentDistribution claims:', claims);
    const promise = new Promise((resolve, reject) => {
      this.arService.saveInsurancePaymentDistributions(claims, this.currentARPayment.PaymetnID, insuranceOverPayList, insuranceClaimItemOverPayList, this.showOnlyCurrentPatient ? this.currentPatientID : null, this.isClaimRefusal)
        .subscribe(resolve, reject);
    });
    return promise;
  }

  openDrawInNewWindow(documentTag: string): void {
    console.log('openDrawInNewWindow documentTag:', documentTag);
    this.selectedDocumentTag = documentTag;
    const tags: string[] = [];
    tags.push(documentTag);
    localStorage.setItem('tags-imaging', JSON.stringify(tags));
    this.uiService.openAcquireDefaultDevice(tags, false, false);
    //this.uiService.openImagingWindow();
    //this.uiService.openAcquire(tags, false);
  }

  openUpload(documentTag: string, fileEnumDescription: string) {
    console.log('openUpload documentTag:', documentTag);
    this.selectedDocumentTag = documentTag;
    this.selectedDocumentDescription = fileEnumDescription;
    document.getElementById('fileInput').click();
  }

  fileSelected(files: FileList) {
    console.log('fileSelected', files);
    //this.isImagesLoading = true;
    const models: DocumentUploadModel[] = [];
    const fz = Array.from(files);

    for (const file of fz) {
      //const fileModel = file;
      const uploadModel = new DocumentUploadModel();
      uploadModel.blob = file;
      uploadModel.docClassId = DocumentClassEnum.Original;
      uploadModel.docTypeId = DocumentTypeEnum.Insurance;
      uploadModel.hasAnnotation = false;
      uploadModel.docTagIds = [this.selectedDocumentTag];
      uploadModel.patientId = this.globals.currentPatientId;
      uploadModel.patientCaseId = this.globals.currentPatientCaseId;
      uploadModel.createDate = this.datePipe.transform(new Date(file.lastModified), 'MMM dd, yyyy H:mm:ss');
      uploadModel.description = this.selectedDocumentDescription;

      models.push(uploadModel);
      if (models.length === files.length) {
        this.fileService.uploadDocuments(models).subscribe((response) => {
          response.documents.forEach(upDoc => {
            console.log('fileSelected upDoc', upDoc);
            this.insuranceDocuments.push(upDoc);
            this.createInsuranceDocumentGroup(upDoc.DocumentID, this.globals.currentPatientId).then((result: any) => {
              console.log('createInsuranceDocumentGroup result:', result);
            });
          });
        }, error => { console.log(error); });
      }
    }
  }

  createInsuranceDocumentGroup(documentID: string, objectID: string) {
    let promise = new Promise((resolve, reject) => {
      const cmodel = new DocumentGroupCreationModel();
      cmodel.documentIds = [documentID];
      cmodel.ObjectId = objectID;
      cmodel.PatientId = this.globals.currentPatientId;
      cmodel.ParentObjectName = 'dataInsurancePayment';
      this.fileService.createDocumentGroup(cmodel).subscribe(resolve, reject);
    });
    return promise;
  }

  updateInsuranceDocumentGroup(documentIDs: string[], objectID: string) {
    let promise = new Promise((resolve, reject) => {
      const cmodel = new DocumentGroupCreationModel();
      cmodel.documentIds = documentIDs;
      cmodel.ObjectId = objectID;
      cmodel.PatientId = this.globals.currentPatientId;
      cmodel.ParentObjectName = 'dataInsurancePayment';
      this.fileService.updateDocumentGroup(cmodel).subscribe(resolve, reject);
    });
    return promise;
  }


  showOnlyCurrentPatientChanged($event: MatCheckboxChange) {
    this.claimsRows = [];
    this.claims = [];
    this.claimTotalNumber = 0;

    if ($event.checked) {
      // patient only checked
      this.isLoading = true;
      this.getAllInsuranceOrganizationsForCurrentPatient().then((results: any) => {
        this.insuranceCompanyList = results;
        this.selectedInsuranceCompany = null;
        this.searchWasEmpty = null;
        this.isLoading = false;

        // set selectedInsuranceCompany and load claims for default patient insurance
        this.setAndLoadClaimsForDefaultPatientInsurance();
      }, err => {
        this.createMessage('Something went wrong', 'Error');
        this.isLoading = false;
      });
    }
    else {
      // all patients
      this.isLoading = true;
      this.getAllInsuranceOrganizations().then((results: any) => {
        this.insuranceCompanyList = results;
        this.selectedInsuranceCompany = null;
        this.isLoading = false;
      }, err => {
        this.createMessage('Something went wrong', 'Error');
        this.isLoading = false;
      });
    }
  }

  setAndLoadClaimsForDefaultPatientInsurance() {
    // load claims for default insurance
    this.insuranceCompanyList.forEach(a => {
      if (a.IsActive && a.InsuranceOrder === 0) {
        this.selectedInsuranceCompany = a;
      }
    });
    if (this.selectedInsuranceCompany) {
      this.LoadClaimsForInsurance();
    }
  }

  createLedgerItemForPayment(payment: DataARPaymentModel) {
    const promise = new Promise((resolve, reject) => {

      const payload = new CreateLedgerItemForPaymentModel();
      payload.PaymentID = payment.PaymetnID;
      payload.enumARLedgerItemOriginTypeID = this.enumLedgerItemOriginTypeInsurance;
      payload.enumARLedgerItemTypeID = LEDGER_ITEM_TYPE.CreditPayment;

      this.arService.createLedgerItemForPayment(payload)
        .subscribe(resolve, reject);
    });
    return promise;
  }

  resetApplyPaymentAmounts() {
    console.log('resetApplyPaymentAmounts');
    this.claimsRows.forEach(claim => {
      claim.ApplyPayment = 0;
      claim.dataARClaimListItems.forEach(item => {
        item.ApplyPayment = 0;
      });
    });
  }

  autoApplyRemainingAmount() {
    console.log('autoApplyRemainingAmount: ', this.paymentAmountNotDistributed);
    let amountRemaining = this.paymentAmountNotDistributed;
    this.claimsRows.forEach(claim => {
      const claimAmountDue = this.returnAmountDue(claim);
      console.log(`autoApplyRemainingAmount claim:${claim.ARClaimID} claimAmountDue: ${claimAmountDue} amountRemaining: ${amountRemaining}`);

      if (amountRemaining <= 0 || claimAmountDue <= 0)
        return;
      let amountDue = claimAmountDue;
      if (amountDue <= 0)
        return;
      
      console.log(`autoApplyRemainingAmount amountDue> 0 claim:${claim.ARClaimID} amountDue: ${amountDue} amountRemaining: ${amountRemaining}`);
      // try to apply payment
      if (amountDue <= amountRemaining) {
        claim.ApplyPayment = ConversionUtilities.roundDecimal(amountDue);
        amountRemaining = ConversionUtilities.roundDecimal(amountRemaining - amountDue);
      }
      else {
        claim.ApplyPayment = ConversionUtilities.roundDecimal(amountRemaining);
        amountRemaining = 0;
        this.paymentAmountNotDistributed = amountRemaining;
      }

      // auto dist to claim items
      if (claim.ApplyPayment) {
        claim.claimExpanded = true;
        let itemsAmountRemaining = ConversionUtilities.roundDecimal(claim.ApplyPayment);
        claim.dataARClaimListItems.forEach(item => {
          // try to apply item payment
          console.log(`autoApplyRemainingAmount claimitem:${item.ARClaimItemID} AmountOutstanding: ${item.AmountOutstanding} itemsAmountRemaining: ${itemsAmountRemaining}`);

          if (item.AmountOutstanding <= itemsAmountRemaining && itemsAmountRemaining > 0) {
            item.ApplyPayment = item.AmountOutstanding;
            itemsAmountRemaining = ConversionUtilities.roundDecimal(itemsAmountRemaining - item.ApplyPayment);
          }
          else {
            item.ApplyPayment = itemsAmountRemaining;
            itemsAmountRemaining = 0;
          }
        });
      }
      // update remaining
      this.paymentAmountNotDistributed = ConversionUtilities.roundDecimal(amountRemaining);

      return true;
    });

    this.showSaveButtonCheck();
  }

  returnAmountDue(claim) {

    let AmountDue = 0;
    if (claim.InsEstimateAmountDue) {
      AmountDue = ConversionUtilities.roundDecimal(claim.InsEstimateAmountDue);
    }

    return AmountDue;
  }

  clearDistributions() {
    // reset payment distributions
    this.resetApplyPaymentAmounts();
    this.setPaymentAmountDistributionRemaining();
    this.contractAllClaimsRows();
  }



  openInsuranceFile(report: any) {
    console.log("Opening report:", report);

    let documentIds: string[] = [];
    documentIds.push(report.ParentDocumentID);

    const config = new MatDialogConfig();
    config.panelClass = 'standard-dialog';
    config.data = documentIds;
    config.maxWidth = '100vw';
    config.maxHeight = '100vh';
    config.width = '98%';
    config.height = '98%';
    console.log('ArInsurancePaymentComponent openInsuranceFile:', config);
    this.dialog.open(TdoOrganizerSlideshowDialogComponent, config).afterClosed().subscribe((res) => {
      //
    });

    /*
let windowOptions = [
'toolbar=no',
'location=no',
'menubar=no',
'height=' + screen.height,
'width=' + screen.width,
'fullscreen=yes' // only works in IE, but here for completeness
].join(',');
const fileSource = this.fileManagerService.getDocumentImageUrl(this.patientId, file.DocumentFileName);
this.messagingService.openPopUpWindow(fileSource, windowOptions, file.DocumentFileName, "", null, true, file.DocumentFileName);
*/
  }


  setPaymentMethod() {
    if (this.isValPay()) {
      this.datePostPaymentMin = new Date();
      if (this.dateReceivedPayment < this.datePostPaymentMin) {
        this.dateReceivedPayment = this.datePostPaymentMin;
      }
      this.isDisabledReceivedDate = true;
    }
    else {
      this.isDisabledReceivedDate = false;
      this.datePostPaymentMin = null;
    }
    this.paymentAmountNotDistributed = this.paymentAmount;
    // try to set ARAccountID
    this.selectedARAccount = null;
    if (this.selectedPaymentMethod.ARAccountID) {
      this.selectedARAccount = this.arAccounts.find(a => a.ARAccountID === this.selectedPaymentMethod.ARAccountID);
    }
    this.contractAllClaimsRows();
    this.autoApplyRemainingAmount();
    this.setMinReceivedDate();
  }

  isValPay() {
    let valPayCheck = false;
    if (this.selectedPaymentMethod?.enumARPayementTypeID === this.enumPaymentTypeE) {
      valPayCheck = true;
    }
    return valPayCheck;
  }

  openPaymentProcessorTotalConfirmation() {
    const pendingToDisperse = this.claimsRows.filter(a => this.returnApplyAmountReamining(a) > 0);
    if (pendingToDisperse.length > 0) {
      this.createMessage(`Please distribute the correct claim payment to procedures before continuing. \nClaims : ${pendingToDisperse.map(c => c.TDOClaimNumber).join(', ')}.`, 'Error');
      return;
    }
    const disperseAmountExceeded = this.claimsRows.filter(a => this.returnApplyAmountReamining(a) < 0);
    if (disperseAmountExceeded.length > 0) {
      this.createMessage(`Please verify that all claim distributions don't exceed claim amount. \nClaims : ${disperseAmountExceeded.map(c => c.TDOClaimNumber).join(', ')}.`, 'Error');
      return;
    }
    // get totals for doctor payments
    this.dataDoctorARPaymentProcessors = [];
    this.claimsRows.forEach(claim => {
      if (claim.ApplyPayment) {
        const docProcessor = this.dataDoctorARPaymentProcessors.find(c => c.DoctorARLocId === claim.DoctorARLocId);
        if (docProcessor) {
          docProcessor.PaymentAmountTotal = docProcessor.PaymentAmountTotal + claim.ApplyPayment;
          docProcessor.DoctorARLocId = claim.DoctorARLocId;
        }
        else {
          const docPP = new DataDoctorArPaymentProcessorModel();
          docPP.PaymentAmountTotal = claim.ApplyPayment;
          docPP.DoctorARLocId = claim.DoctorARLocId;

          this.dataDoctorARPaymentProcessors.push(docPP);
        }
      }
    });

    // processor names
    this.dataDoctorARPaymentProcessors.forEach(name => {
      // get account name
      const doc = this.dataDoctorARPaymentProcessorsAll.find(c => c.DoctorARLocId === name.DoctorARLocId);
      if (doc) {
        name.PaymentProcessorName = doc.PaymentProcessorName;
        name.PaymentProcessorId = doc.PaymentProcessorId;
      }
      // get account name
      const acct = this.arAccounts.find(c => c.DoctorARLocId === name.DoctorARLocId);
      if (acct) {
        name.ARAccountName = acct.AccountName;
      }
    });

    // open dialog
    if (this.dataDoctorARPaymentProcessors.length > 0) {
      const promise = new Promise((resolve, reject) => {
        const dialogRef = this.dialog.open(ArInsurancePaymentProcessorTotalConfirmComponent, {
          panelClass: 'dialog',
          width: '700px',
          height: '390px',
          disableClose: true,
          data: {
            totals: this.dataDoctorARPaymentProcessors,
            paymentMethod: this.selectedPaymentMethod,
            arAccounts: this.arAccounts,
            claims: this.claimsRows,
            patientId: this.showOnlyCurrentPatient ? this.currentPatientID : null,
          }
        });
        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            this.changesMade = true;
            // reset claims
            this.LoadClaimsForInsurance();
            // reset expansion status
            this.claimExpanded = '';
          }
        });
      });
      return promise;
    }
    else {
      this.createMessage('No claims have been selected', 'Error');
    }
  }

  claimItemActionSelected(claim: DataARClaimListModel, claimitem: DataARClaimItemListModel) {
    this.setMinReceivedDate();
    // should all claim items be set to same action?
    if (claim.dataARClaimListItems.length > 1) {
      this.dialogService.openConfirmDialog('Set all other items in this claim to same action?', true, false).subscribe((res) => {
        if (res) {
          // loop through other claim items
          claim.dataARClaimListItems.forEach(a => {
            a.enumARInsurancePaymentActionID = claimitem.enumARInsurancePaymentActionID;
          });
        }
      });
    }
  }

  clearSearchBox() {
    const keyEvent = new KeyboardEvent('keydown');
    Object.defineProperty(keyEvent, 'keyCode', {
      get: () => ''
    });
    Object.defineProperty(keyEvent, 'target', {
      get: () => ''
    });

    this.searchInput = '';

    this.searchChanged(keyEvent);
  }

  expandAllClaimsRows() {
    this.claimsRows.forEach(a => {
      a.claimExpanded = true;
    });
  }

  contractAllClaimsRows() {
    this.claimsRows.forEach(a => {
      a.claimExpanded = false;
    });
  }

  returnApplyAmountReamining(claim: DataARClaimListModel) {
    let claimItemsApplyTotal: number = 0;
    claim.dataARClaimListItems.forEach(a => {
      if (a.ApplyPayment) {
        claimItemsApplyTotal += a.ApplyPayment;
      }
    });
    return ConversionUtilities.roundDecimal(claim.ApplyPayment - claimItemsApplyTotal);
  }

  cancelClicked() {
    this.close(this.changesMade);
  }

  includeClosedClaimsChanged($event: MatCheckboxChange) {
    this.claimsRows = [];
    this.claimTotalNumber = 0;
    console.log('includeClosedClaimsChanged this.selectedInsuranceCompany: ', this.selectedInsuranceCompany);
    console.log('includeClosedClaimsChanged this.includeClosed: ', this.includeClosed);

    if (this.selectedInsuranceCompany) {
      this.LoadClaimsForInsurance();
    }
  }

  processPayment() {
    if (this.isValPay())
      this.openPaymentProcessorTotalConfirmation();
    else {
      this.showSaveButtonCheck();
      if (this.showSaveButton)
        this.savePaymentDistributionBalanceCheck();
    }
  }

  loadClaimRefusal() {
    this.isClaimRefusal = true;
    console.log('isClaimRefusal:', this.isClaimRefusal);

    const promises2 = [
      this.getInsuranceClaimForLedgerID(this.data.LedgerItem.ARTransactionItemID)
    ];

    Promise.all(promises2).then((results2: any) => {
      if (results2) {
        this.insuranceCompanyList.forEach(a => {
          if (a.InsuranceID === results2[0].InsuranceID) {
            this.selectedInsuranceCompany = a;
          }
        });

        this.insuranceName = results2[0].InsuranceName;
        this.selectedARAccount = this.arAccounts.find(a => a.ARAccountID = results2[0].ARAccountID);
        this.claims = results2[0].TheClaim;
        this.claimsRows = this.claims;
        this.claimExpanded = results2[0].ARClaimID;
        this.selectedPaymentMethod = new CfgARPaymentMethodModel();
        this.selectedPaymentMethod.enumARPayementCCTypeID = null;
        this.selectedPaymentMethod.enumARPayementETypeID = null;
        this.selectedPaymentMethod.enumARPayementTypeID = EnumARPaymentType.Check;

        this.claimsRows.forEach(a => {
          a.DoctorARLocId = this.selectedARAccount.DoctorARLocId;
          a.MarkedForClose = true;
          a.ApplyPayment = 0;
          a.dataARClaimListItems.forEach(b => {
            b.enumARInsurancePaymentActionID = this.enumARInsurancePaymentActionPatientPay;
            b.ApplyPayment = 0;
          });
        });
        this.isClaimsLoading = false;
      }
    }, err => {
      this.createMessage('Something went wrong', 'Error');
      this.isClaimsLoading = false;
    });

    this.paymentAmount = 0;
    this.datePostPayment = new Date();
    this.dateReceivedPayment = new Date();
  }

  selectInsurance(event: Event) {
    event.stopPropagation();
    console.log('selectInsurance: ', this.isSelectingInsurace);
    if (this.isSelectingInsurace)
      return;
    this.isSelectingInsurace = true;

    const dialogRef = this.dialog.open(TdoSelectDialogComponent, {
      data: {
        dataSource: this.insuranceCompanyList,
        tableTitle: 'Select Insurance Company',
        columnDefinitions: [['Insurance Name', 'OrganizationName', true]],
        isSearchable: true
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.isSelectingInsurace = false;
      console.log(' selectInsurance result', result);
      // return result
      if (result) {
        // select insurance
        this.selectedInsuranceCompany = result;
        this.LoadClaimsForInsurance();
      }
    }, err => {
    });
  }

  getInsuranceDocuments() {
    const promise = new Promise((resolve, reject) => {
      this.fileService.getInsuranceDocuments(this.currentPatientID, this.currentARPayment?.PaymetnID ?? Constants.emptyGuid)
        .subscribe(resolve, reject);
    });
    return promise;
  }

}
